const {
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  withStyles,
  Divider,
  Chip,
} = window.Material;

const { Star, StarBorder, Chat, GroupWork, Lock } = window.MaterialIcons;

const moment = window.moment;

import { FILTERED_INDICATORS } from "../../../../../constants";
import { mimeTypeIcon } from "../../../../../constants";
import { ContentContext } from "../../../../../utils/contexts";

import { savePreferences } from "../../../../../actions";

const styles = {
  avatar: {
    fontSize: '22px',
    minWidth: 'auto',
    marginRight: '10px',
    color: '#8e8e8e',
    '& .green': {
      color: 'green',
    },
    '& .red': {
      color: 'red',
    },
    '& .blue': {
      color: '#0e1f3e',
    },
  },
  divider: {
    margin: '0 !important',
  },
  item: {
    paddingLeft: '16px !important',
    paddingTop: '0',
    paddingBottom: '0',
  },
  link: {
    fontSize: '13px',
    '&:hover': {
      color: '#0c79bf !important',
    },
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  tags: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '5px',
      margin: '0 5px 0 0',
    },
  },
  lock: {
    backgroundColor: 'red',
    color: 'white',
    display: 'inline-flex',
    flexWrap: 'wrap',
    fontSize: '10px',
    alignItems: 'center',
  },
  text: {
    maxWidth: '50%',
    fontSize: '13px',
    wordBreak: 'break-all',
  },
  chipLabel: {
    paddingRight: '3px',
    paddingLeft: '3px',
  },
  favourite: {
    color: '#ff9a00',
  },
};

class File extends React.PureComponent {
  onClick = () => {
    const { item } = this.props;
    const { onItemSelect } = this.context;

    onItemSelect(item);
  };

  addToFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteDocuments, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteDocuments,
      [nodeRef]: nodeRef,
    };

    await savePreferences({
      org: { alfresco: { share: { documents: { favourites: Object.keys(newFavourites).join(',') } } } },
    });

    fetchPreferences();
  };

  removeFromFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteDocuments, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteDocuments,
    };

    delete newFavourites[nodeRef];

    await savePreferences({
      org: { alfresco: { share: { documents: { favourites: Object.keys(newFavourites).join(',') } } } },
    });

    fetchPreferences();
  };

  render() {
    const {
      item: { properties, name, nodeRef, indicators, mimetype, workingCopy, version, isLocked, disabled },
      classes,
      index,
    } = this.props;

    const { selected, hidden, loadingContent, favouriteDocuments } = this.context;

    const isSelected = Boolean(selected[nodeRef]);
    const isHidden = Boolean(hidden[nodeRef]);
    const isInFavourites = favouriteDocuments[nodeRef];

    const currentDay = moment();
    const modifiedDate = moment(properties['cm:modified'].iso8601);
    const hourDifference = currentDay.diff(modifiedDate, 'seconds') / 60 / 60;
    let time = '';
    const isOneDay = hourDifference > 24 && hourDifference < 47;
    if (hourDifference > 24) {
      //Days
      if (isOneDay) {
        //Day
        time = window.Alfresco.messages.global['relative.day'];
      } else {
        // more than 1 day
        time = Math.round(hourDifference / 24) + ` ${window.Alfresco.messages.global['date-unit.plural.day']}`;
      }
    } else {
      if (hourDifference > 1) {
        //Hours
        time = Math.round(hourDifference) + ` ${window.Alfresco.messages.global['date-unit.plural.hour']}`;
      } else {
        //Minutes
        time = Math.round(hourDifference * 60) + ` ${window.Alfresco.messages.global['date-unit.plural.minute']}`;
      }
    }

    const hasWorkflows = indicators.find(indicator => indicator.id === 'active-workflows');
    const isLockedAlt = indicators.find(indicator => indicator.id === 'lock-owner' || indicator.id === 'nodeLock');
    const fileIconClass = mimeTypeIcon[mimetype];
    return (
      <React.Fragment>
        <ListItem
          disableRipple
          disableTouchRipple
          button
          selected={isSelected}
          disabled={isHidden || loadingContent || disabled}
          onClick={this.onClick}
          classes={{ root: classes.item }}
          id={`docLibItem${index}`}
        >
          <ListItemAvatar className={classes.avatar}>
            <i className={`fas fa-${isSelected ? 'check-circle blue' : fileIconClass}`} />
          </ListItemAvatar>
          <ListItemText
            classes={{ primary: classes.text, secondary: classes.text }}
            primary={`${name}${window.Edocat?.Config?.showTitle && properties['cm:title'] ? ` (${properties['cm:title']})` : ''}`}
            secondary={`${
              window.Alfresco.messages.global[
                `${isOneDay ? 'prop.cm_modified.title' : 'edocat.document-library.edited'}`
                ]
            } ${time} ${properties['cm:modifier'].displayName}`}
          />
          <ListItemSecondaryAction classes={{ root: classes.actions }}>
            {properties['cm:taggable'] && (
              <div className={classes.tags}>
                {properties['cm:taggable'].map(tag => (
                  <Chip key={tag.name} label={tag.name} />
                ))}
              </div>
            )}
            {(workingCopy || isLocked) && properties['cm:workingCopyOwner'] && (
              <div className={classes.tags}>
                <Tooltip
                  title={`${window.Alfresco.messages.global['edocat.document-library.lock-message']} ${properties['cm:workingCopyOwner'].displayName} (${properties['cm:workingCopyOwner'].userName})`}
                >
                  <Chip id={`lockedBtn-docLibItem${index}`} classes={{ root: classes.lock, label: classes.chipLabel }} label={<Lock fontSize="small" />} />
                </Tooltip>
              </div>
            )}
            {isLockedAlt && properties['cm:lockOwner'] && (
              <div className={classes.tags}>
                <Tooltip
                  title={`${window.Alfresco.messages.global['edocat.document-library.lock-message']} ${properties['cm:lockOwner'].displayName} (${properties['cm:lockOwner'].userName})`}
                >
                  <Chip classes={{ root: classes.lock, label: classes.chipLabel }} label={<Lock fontSize="small" />} />
                </Tooltip>
              </div>
            )}
            {/*indicators.length > 0 &&
              indicators
                .filter(indicator => !FILTERED_INDICATORS.includes(indicator.id))
                .map(indicator => (
                  <Tooltip
                    title={window.Alfresco.messages.global[indicator.label] || indicator.label}
                    key={indicator.id}
                  >
                    <span
                      className="hasIndicator"
                      style={{
                        backgroundImage: `url(${window.appContext}/res/components/documentlibrary/indicators/${indicator.icon})`,
                      }}
                    />
                  </Tooltip>
                ))*/}
            {Boolean(parseInt(properties['fm:commentCount'])) && (
              <div className={classes.tags}>
                <Chip icon={<Chat fontSize="small" />} label={properties['fm:commentCount']} />
              </div>
            )}
            {hasWorkflows && (
              <div className={classes.tags}>
                <Tooltip title={window.Alfresco.messages.global['edocat.document-library.indicator.workflow']}>
                  <Chip label={<GroupWork fontSize="small" />} classes={{ label: classes.chipLabel }} />
                </Tooltip>
              </div>
            )}
            <div className={classes.tags}>
              <Tooltip title={window.Alfresco.messages.global['edocat.all-workflows.filter.document-version']}>
                <Chip label={version} classes={{ label: classes.chipLabel }} />
              </Tooltip>
            </div>
            <Tooltip
              title={
                isInFavourites
                  ? window.Alfresco.messages.global['favourite.document.remove.tip']
                  : window.Alfresco.messages.global['favourite.document.add.tip']
              }
            >
              <IconButton
                onClick={isInFavourites ? this.removeFromFavourites : this.addToFavourites}
                id={`docLibItem${index}FavouriteBtn`}
                disabled={loadingContent}
              >
                {isInFavourites ? <Star fontSize="small" classes={{ root: classes.favourite }} /> : <StarBorder fontSize="small" />}
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
        <Divider classes={{ root: classes.divider }} />
      </React.Fragment>
    );
  }
}

File.contextType = ContentContext;

export default withStyles(styles)(File);
